import { render, staticRenderFns } from "./SelectCoverDialog.vue?vue&type=template&id=24d55cca&scoped=true"
import script from "./SelectCoverDialog.vue?vue&type=script&lang=js"
export * from "./SelectCoverDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectCoverDialog.vue?vue&type=style&index=0&id=24d55cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d55cca",
  null
  
)

export default component.exports